// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"4a6a770b","206":"4a6a770b","265":"745d5fce"}[chunkId] + ".chunk.css";
};